export const defaultOptions = {
  width: 560,
  height: 400,
  media: 'twitter',
  url: window.location.href,
  text: document.title,
};

class SocialShare {
  /**
   * @constructor
   */
  constructor(options) {
    this.options = { ...defaultOptions, ...options };

    this.element = this.options.element;
    this.media = this.options.media;
    this.url = this.options.url || window.location.href;
    this.text = this.options.text || document.title;

    if (!this.element) {
      throw new Error('Social share anchor element is required');
    }

    this.populateLink();

    this.element.addEventListener('click', this.onLinkClick.bind(this));
  }

  /**
   * Populate the link href
   */
  populateLink() {
    const hashtag = this.options.hashtag ? `&hashtags=${this.options.hashtag}` : '';
    const encodedUrl = encodeURIComponent(this.url);
    const encodedText = encodeURIComponent(this.text);

    switch (this.media) {
      case 'facebook':
        this.element.href = `https://www.facebook.com/sharer.php?u=${encodedUrl}`;
        break;
      case 'twitter':
        this.element.href = `https://twitter.com/share?url=${encodedUrl}&text=${encodedText}${hashtag}`;
        break;
      case 'linkedin':
        this.element.href = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedText}`;
        break;
      case 'reddit':
        this.element.href = `https://reddit.com/submit?url=${encodedUrl}&title=${encodedText}`;
        break;
      case 'mail':
      case 'email':
        this.element.href = `mailto:?subject=${encodedText}&body=${encodedUrl}`;
    }
  }

  /**
   * @param {Event} - click event
   */
  onLinkClick(event) {
    const medias = ['facebook', 'twitter', 'linkedin', 'reddit'];

    if (medias.includes(this.media)) {
      event.preventDefault();
      this.openPopup(event.currentTarget.href);
    }
  }

  /**
   * open popup window
   */
  openPopup(url, title = 'Share') {
    const top = (window.innerHeight - this.options.height) / 2;
    const left = (window.innerWidth - this.options.width) / 2;
    const status = 1;
    const windowOptions = `status=${status},width=${this.options.width},height=${this.options.height},top=${top},left=${left}`;

    window.open(url, title, windowOptions);
  }
}

export default SocialShare;
